import { DARK_THEME } from "../types/darkThemeTypes";

export const DarkTheme = (data) => ({
    type: DARK_THEME,
    payload: data
})

